"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
require("../../foundations/fonts");
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _excluded = ["label", "children", "font", "pink", "teal", "darkTeal", "darkYellow", "darkOrange", "darkerTeal", "darkestTeal", "darkGrey", "white", "transparent", "cream", "inverted"];
var _templateObject;
var ButtonStyles = _styledComponents.default.button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  --second-color: var(--bf-core-white);\n  border-radius: 500px;\n  border: 2px solid rgba(0, 0, 0, 0);\n  background-color: var(--main-color);\n  color: var(--second-color);\n  padding: 10px 20px;\n  line-height: 14px;\n  font-family: var(", ");\n  font-size: 14px;\n  transition: background-color 0.1s ease, color 0.1s ease, border 0.1s ease;\n  width: ", ";\n\n  @media (min-width: ", ") {\n    font-size: 16px;\n    line-height: 16px;\n  }\n\n  &:hover {\n    background-color: var(--second-color);\n    color: var(--main-color);\n    border: 2px solid var(--main-color);\n  }\n\n  /* colors */\n  &.pink {\n    --main-color: var(--bf-core-pink);\n  }\n\n  &.teal {\n    --main-color: var(--bf-core-teal);\n  }\n\n  &.darkTeal {\n    --main-color: var(--bf-core-dark-teal);\n  }\n\n  &.darkYellow {\n    --main-color: var(--bf-dark-yellow);\n  }\n\n  &.darkOrange {\n    --main-color: var(--bf-dark-orange);\n  }\n\n  &.darkerTeal {\n    --main-color: var(--bf-darker-teal);\n  }\n\n  &.darkestTeal {\n    --main-color: var(--bf-darkest-teal);\n  }\n\n  &.darkGrey {\n    --main-color: var(--bf-dark-grey);\n  }\n\n  &.transparent {\n    --main-color: var(--bf-core-pink);\n  }\n\n  &.white {\n    --main-color: var(--bf-core-white);\n    --second-color: var(--bf-core-black);\n\n    &:not(.inverted):not(:hover):not(.cream) {\n      mix-blend-mode: screen;\n    }\n  }\n\n  &.white::before {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: white;\n    border-radius: 500px;\n    content: \"\";\n    mix-blend-mode: color-burn;\n  }\n\n  /* backgrounds */\n  &.inverted {\n    color: var(--main-color);\n    background: rgba(0, 0, 0, 0);\n    border: 2px solid var(--main-color);\n    /* line-height: 12px; */\n    font-weight: 500;\n\n    &:hover {\n      color: var(--second-color);\n      background: var(--main-color);\n    }\n  }\n\n  &.cream {\n    background: var(--bf-op45-core-cream);\n    color: var(--main-color);\n    font-weight: 500;\n  }\n\n  &.transparent {\n    background: transparent;\n    color: var(--main-color);\n    font-weight: 500;\n    border-left: transparent;\n    border-right: transparent;\n    border-radius: 0px;\n  }\n"])), function (_ref) {
  var font = _ref.font;
  return "--bf-".concat(font, "-font");
}, function (props) {
  return props.fullWidth ? '100%' : '';
}, _bfBaseStyles.Breakpoints.s);
function Button(_ref2) {
  var label = _ref2.label,
    children = _ref2.children,
    _ref2$font = _ref2.font,
    font = _ref2$font === void 0 ? "lead" : _ref2$font,
    pink = _ref2.pink,
    teal = _ref2.teal,
    darkTeal = _ref2.darkTeal,
    darkYellow = _ref2.darkYellow,
    darkOrange = _ref2.darkOrange,
    darkerTeal = _ref2.darkerTeal,
    darkestTeal = _ref2.darkestTeal,
    darkGrey = _ref2.darkGrey,
    white = _ref2.white,
    transparent = _ref2.transparent,
    cream = _ref2.cream,
    inverted = _ref2.inverted,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var className = Object.entries({
    pink: pink,
    teal: teal,
    darkTeal: darkTeal,
    darkYellow: darkYellow,
    darkOrange: darkOrange,
    darkerTeal: darkerTeal,
    darkestTeal: darkestTeal,
    darkGrey: darkGrey,
    transparent: transparent,
    white: white
  }).find(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      select = _ref4[1];
    return select;
  });
  return _react.default.createElement(ButtonStyles, Object.assign({
    font: font,
    type: "button",
    className: (className ? className[0] : "pink") + (inverted ? " inverted" : "") + (cream ? " cream" : ""),
    href: props.buttonUrl
  }, props), children || label);
}
;
var _default = Button;
exports.default = _default;